import englishTranslation from '../translations/en.json';
import italianTranslation from '../translations/it.json';
import frenchTranslation from '../translations/fr.json';

type LocaleCode = 'en' | 'it' | 'fr';

const locales: LocaleCode[] = ['en', 'it', 'fr'];

const translation = {
	en: englishTranslation,
	it: italianTranslation,
	fr: frenchTranslation,
};

type LocalizedTexts = Record<LocaleCode, string>;

type TextsToLocalize = Record<LocaleCode, string | undefined>;

export { translation, locales };
export type { LocaleCode, LocalizedTexts, TextsToLocalize };
